/**
 * This file was initially generated by scripts/createStrapiComponent/create-strapi-component.js.
 * Feel free to modify it as needed.
 */
import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';

import { BackgroundRemover } from './BackgroundRemover';
import { collectBackgroundRemoverComponentParams } from './collector';
import { BackgroundRemoverStrapi } from './types';

// [CREATE-SCRIPT]: This is a template. Feel free to modify it as needed.
export class BackgroundRemoverComponentBuilder extends ComponentBuilder {
  public key = 'micro-apps.background-remover' as const;

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const fieldName = this.getFieldNameSymbol(inputs.componentData);

    const page = await inputs.fetchManager.addRequestOptionsAndWaitForResponse<{
      fieldName: BackgroundRemoverStrapi;
    }>({
      populate: {
        [fieldName]: {
          populate: {
            background: true,
          },
        },
      },
    });

    const componentData = page[fieldName];
    if (!componentData) {
      return undefined;
    }

    const data = collectBackgroundRemoverComponentParams(page[fieldName]);

    return data || null;
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs) {
      return <BackgroundRemover {...inputs} />;
    } else {
      return null;
    }
  }
}
